/** @prettier */
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

const StyledSpan = ({ short, registered, size }) => (
  <Fragment>
    <span
      style={{
        fontSize: `${size ? `${size}px` : 'inherit'}`,
        lineHeight: `${size ? `${size}px` : 'inherit'}`,
      }}
    >
      {short ? 'MB' : 'Matchbook'}
    </span>
    {registered ? (
      <span
        style={{
          fontSize: `${size ? `${Math.ceil((size * 2) / 3)}px` : 'inherit'}`,
          lineHeight: `${size ? `${Math.ceil((size * 2) / 3)}px` : 'inherit'}`,
        }}
      >
        ®
      </span>
    ) : null}
  </Fragment>
);

StyledSpan.propTypes = {
  short: PropTypes.bool,
  registered: PropTypes.bool,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default StyledSpan;
